import { Component, computed, inject, input, OnInit, signal } from '@angular/core';
import { ApprovalFormItem } from '@mwe/models';
import { isArrayWithMinOneItem } from '@mwe/utils';
import { NgClass } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@mwe/ui/pipes';
import { PriceSheetService } from '@mwe/services';

@Component({
  selector: 'mwe-approval-form-item',
  templateUrl: './approval-form-item.component.html',
  imports: [NgClass, TranslateDirective, TranslatePipe, SafeHtmlPipe],
})
export class ApprovalFormItemComponent implements OnInit {
  protected readonly priceSheetService = inject(PriceSheetService);

  readonly item = input.required<ApprovalFormItem>();
  readonly isApprovalFirmDirty = input.required<boolean>();

  readonly isItemDirty = signal<boolean>(false);
  readonly isChecked = signal<boolean>(false);

  readonly isValid = computed<boolean>(() => !this.isCheckboxMandatory() || this.isChecked());
  readonly labelId = computed<string>(() => `${this.item().id}-checkbox`);
  readonly hasCheckbox = computed<boolean>(() => !!this.item().checkbox);
  readonly hasBulletPoints = computed<boolean>(() => isArrayWithMinOneItem(this.item().bulletPoints));
  readonly hasText = computed<boolean>(() => !!this.item().text);
  readonly isCheckboxMandatory = computed<boolean>(() => this.hasCheckbox() && this.item().checkbox.isMandatory);
  readonly errorId = computed<string>(() => `form-input-desc--${this.item().id}`);
  readonly isErrorVisible = computed<boolean>(() => {
    if (!this.isApprovalFirmDirty() && !this.isItemDirty()) {
      return false;
    }

    return !this.isValid();
  });

  ngOnInit(): void {
    this.isChecked.set(this.item().checkbox?.initialValue);
  }

  onCheckBoxChanged(checked: boolean) {
    this.isChecked.set(checked);
    this.isItemDirty.set(true);
  }
}
